class QuizResultV2 extends HTMLElement {
  constructor() {
    super();

    this.tiles = this.querySelectorAll(".quiz-result-group-tile");

    this.registerEvents();
  }

  registerEvents() {
    this.tiles.forEach((tile) => {
      tile.addEventListener("click", () => {
        tile.scrollIntoView({ behavior: "smooth" });
        const groupId = tile.dataset.groupId;
        this.toggle(groupId);
      });
    });
  }

  toggle(groupId) {
    const currentActiveTile = this.querySelector(
      ".quiz-result-group-tile[data-active='true']"
    );
    const currentActiveGroup = this.querySelector(
      ".quiz-result-group-wrapper[data-active='true']"
    );

    currentActiveTile.setAttribute("data-active", "false");
    currentActiveGroup.setAttribute("data-active", "false");

    const newActiveTile = this.querySelector(
      `.quiz-result-group-tile[data-group-id='${groupId}']`
    );
    const newActiveGroup = this.querySelector(
      `.quiz-result-group-wrapper[data-group-id='${groupId}']`
    );

    newActiveTile.setAttribute("data-active", "true");
    newActiveGroup.setAttribute("data-active", "true");
  }
}

customElements.define("quiz-result-v2", QuizResultV2);
